<template>
  <div>
    <div class="box" v-show="form_flag === 0">
      <div class="field is-grouped">
        <div class="control">
          <button type="button" class="button is-danger" @click="goToDashboard()">Back to Dashboard</button>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-3" v-for="(event_row, index) in event_list" :key="index" @click="selectEvent(event_row, index)">
          <article :class="{'tile is-child notification has-text-centered': true, 'is-danger': event_row.is_selected === 0, 'is-warning': event_row.is_selected === 1}">
            <p class="title" v-text="event_row.title"></p>
          </article>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-12">
          <div class="tile is-parent" v-for="(edc_bank_row, index) in edc_bank_list" :key="index" @click="selectEDC(edc_bank_row, index)">
            <article :class="{'tile is-child notification has-text-centered': true, 'is-link': edc_bank_row.is_selected === 0, 'is-warning': edc_bank_row.is_selected === 1}">
              <p class="title" v-text="edc_bank_row.title"></p>
            </article>
          </div>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-12">
          <div class="tile is-parent" v-for="(payment_type_row, index) in payment_type_list" :key="index" @click="selectPaymentType(payment_type_row, index)">
            <article :class="{'tile is-child notification has-text-centered': true, 'is-success': payment_type_row.is_selected === 0, 'is-warning': payment_type_row.is_selected === 1}">
              <p class="title" v-text="payment_type_row.title"></p>
            </article>
          </div>
        </div>
      </div>
    </div>
    <div class="box" v-show="form_flag === 1">
      <div class="field is-grouped">
        <button class="button is-danger" @click="goToSelection()">Back to Selection</button>
      </div>
      <div class="columns">
        <div class="column is-4">
          <div class="overflow-table">
            <table class="table is-bordered is-fullwidth is-narrow">
              <tr>
                <th>Amount</th>
                <th>Tickets</th>
                <th>Action</th>
              </tr>
              <tr v-for="(calculation_row, index) in calculation_list" :key="index">
                <td v-text="'Rp. ' + calculation_row.total_string"></td>
                <td v-text="calculation_row.tickets"></td>
                <td>
                  <button type="button" class="button is-warning" @click="addNote(index)"><i class="fa fa-sticky-note"></i></button>
                  <button type="button" class="button is-success" @click="editCalculation(index)"><i class="fa fa-edit"></i></button>
                  <button type="button" class="button is-danger" @click="removeCalculation(index)"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </table>
          </div>
          <h3 class="title is-3" v-text="'Total Tickets : ' + this.numberFormat(this.total_tickets, '.')"></h3>
          <h3 class="title is-3" v-text="'Total : Rp. ' + this.all_total_string"></h3>
        </div>
        <div class="column is-8">
          <div class="columns is-multiline is-mobile">
            <div class="column is-8">
              <h1 class="title is-1" v-text="'Rp. ' + total_string"></h1>
            </div>
            <div class="column is-4">
              <article class="notification is-warning title is-4" @click="getModalConfirmation('Event', 'Are you sure your input already correct?\nTotal input : Rp. ' + all_total_string, 'submit')">Submit</article>
            </div>
            <div class="column is-8">
              <div class="columns is-multiline is-mobile">
                <div class="column is-4 has-text-centered" v-for="(number_row, index) in number_list" :key="index">
                  <article class="notification is-info title is-4" @click="addNumber(number_row)" v-text="number_row.label"></article>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="columns is-multiline is-mobile">
                <div class="column is-12 has-text-centered">
                  <article class="notification is-link title is-4" @click="backSpace()"><i class="fa fa-arrow-left"></i></article>
                </div>
                <div class="column is-12 has-text-centered">
                  <article class="notification is-link title is-4" @click="clearNumber()">C</article>
                </div>
                <div class="column is-12 has-text-centered">
                  <article class="notification is-success title is-4" @click="addToList()">+</article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="submitData"></confirmation-modal>
  </div>
</template>

<script>
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      list_breadcrumbs: [
        {
          title: 'Frontdesk',
          path: '/panel/frontdesk/'
        },
        {
          title: 'Dashboard',
          path: '/panel/frontdesk/dashboard'
        },
        {
          title: 'Event',
          path: ''
        }
      ],
      selected_service: '',
      selected_counter: '',
      selected_edc: [],

      form_flag: 0,
      header_title: '',
      edc_bank_list: [],
      edc_bank_data: {},
      payment_type_list: [],
      payment_type_data: {},
      event_list: [],
      event_data: {},
      selection_list: [],
      total_label: '0',
      total_string: '0',
      total: 0,
      all_total: 0,
      all_total_string: '0',
      total_tickets: 0,
      number_list: [
        { type: 'addition', label: '7', number: 7 },
        { type: 'addition', label: '8', number: 8 },
        { type: 'addition', label: '9', number: 9 },
        { type: 'addition', label: '4', number: 4 },
        { type: 'addition', label: '5', number: 5 },
        { type: 'addition', label: '6', number: 6 },
        { type: 'addition', label: '1', number: 1 },
        { type: 'addition', label: '2', number: 2 },
        { type: 'addition', label: '3', number: 3 },
        { type: 'multiply', label: '0', number: 10 },
        { type: 'multiply', label: '00', number: 100 },
        { type: 'multiply', label: '000', number: 1000 }
      ],
      calculation_list: [],
      update_flag: 0,
      update_index: 0,
      modal_content: '',
      submit_modal_flag: false
    }
  },
  created () {
    this.getEDCBankList()
    this.getPaymentType()
    this.getEvent()

    this.selected_service = this.getSessionItem('selected_service')
    this.selected_counter = this.getSessionItem('selected_counter')

    if (this.selected_service === null || this.selected_counter === null) {
      this.$router.push('/panel/frontdesk')
    }
  },
  methods: {
    goToDashboard () {
      this.$router.push('/panel/frontdesk/dashboard')
    },
    getEDCBankList () {
      var self = this
      self.flyGetSession('frontdesk/get_edc_bank')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.edc_bank_list = response.data.data

          for (var index in self.edc_bank_list) {
            if (self.getSessionItem('edc_bank_' + self.edc_bank_list[index].id) === null) {
              self.$router.push('/panel/frontdesk')
            }
            var tempData = {
              edc_bank_id: self.edc_bank_list[index].id,
              edc_id: self.getSessionItem('edc_bank_' + self.edc_bank_list[index].id)
            }

            self.selected_edc.push(tempData)
          }
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    selectEDC (rowData, index) {
      this.edc_bank_data = {}
      for (var indexData in this.edc_bank_list) {
        this.edc_bank_list[indexData].is_selected = 0
      }

      this.edc_bank_list[index].is_selected = 1
      this.edc_bank_data = this.edc_bank_list[index]

      this.setSelection('edc')
    },
    getPaymentType () {
      var self = this
      self.flyPostSession('frontdesk/get_payment_type', {
        type: 1
      })
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.payment_type_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    selectPaymentType (rowData, index) {
      this.payment_type_data = {}
      for (var indexData in this.payment_type_list) {
        this.payment_type_list[indexData].is_selected = 0
      }

      this.payment_type_list[index].is_selected = 1
      this.payment_type_data = this.payment_type_list[index]

      this.setSelection('payment_type')
    },
    getEvent () {
      var self = this
      self.flyGetSession('frontdesk/get_event')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.event_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    selectEvent (rowData, index) {
      this.event_data = {}
      for (var indexData in this.event_list) {
        this.event_list[indexData].is_selected = 0
      }

      this.event_list[index].is_selected = 1
      this.event_data = this.event_list[index]

      this.setSelection('event')
    },
    setSelection (inputLabel) {
      var tempSelectionData = this.selection_list.filter(function (tempData) {
        if (tempData.label === inputLabel) {
          return tempData
        }
      })

      if (tempSelectionData.length <= 0) {
        var addSelection = {
          label: inputLabel
        }
        this.selection_list.push(addSelection)

        if (this.selection_list.length >= 3) {
          this.form_flag = 1
        }
      }
    },
    goToSelection () {
      this.form_flag = 0
      this.selection_list = []
      for (var index in this.edc_bank_list) {
        this.edc_bank_list[index].is_selected = 0
      }
      for (index in this.payment_type_list) {
        this.payment_type_list[index].is_selected = 0
      }
      for (index in this.event_list) {
        this.event_list[index].is_selected = 0
      }
      this.calculation_list = []
      var calculateAll = this.calculateAll()
      this.all_total = calculateAll.total
      this.all_total_string = this.numberFormat(this.all_total, '.')
      this.total_tickets = calculateAll.total_tickets
      this.total = 0
      this.total_label = '0'
      this.total_string = '0'
    },
    addNumber (numberRow) {
      if (this.total_label === '0') {
        this.total_label = numberRow.label
      } else {
        this.total_label = this.total_label + numberRow.label
      }
      this.total = parseInt(this.total_label)
      this.total_string = this.numberFormat(this.total, '.')
    },
    clearNumber () {
      this.total_label = '0'
      this.total = parseInt(this.total_label)
      this.total_string = this.numberFormat(this.total, '.')
    },
    backSpace () {
      if (this.total_label !== '0') {
        this.total_label = this.total_label.slice(0, -1)
      }
      if (this.total_label === '') {
        this.total_label = '0'
      }
      this.total = parseInt(this.total_label)
      this.total_string = this.numberFormat(this.total, '.')
    },
    getEventTicket (total) {
      var ticket = 0
      if (this.event_data.ticket_type === 0 || this.event_data.ticket_type === 2) {
        ticket = total / this.event_data.price
      } else if (this.event_data.ticket_type === 1) {
        var tempTicket = 0
        var variantPrice = this.event_data.variant_price
        for (var index in variantPrice) {
          if (ticket === 0) {
            tempTicket = total / variantPrice[index].price
            if (variantPrice[index].maximal_unlimited === 0) {
              if (variantPrice[index].minimal <= tempTicket && variantPrice[index].maximal >= tempTicket) {
                ticket = tempTicket
              }
            } else {
              if (variantPrice[index].minimal <= tempTicket) {
                ticket = tempTicket
              }
            }
          }
        }
      }

      return ticket
    },
    addToList () {
      var calculateAll = ''
      if (this.total > 0) {
        var tempCalculation = {
          total_label: this.total_label,
          total: parseInt(this.total),
          total_string: this.total_string,
          tickets: this.getEventTicket(this.total)
        }
        this.clearNumber()

        if (this.update_flag === 1) {
          this.calculation_list[this.update_index] = tempCalculation
          calculateAll = this.calculateAll()
          this.all_total = calculateAll.total
          this.all_total_string = this.numberFormat(this.all_total, '.')
          this.total_tickets = calculateAll.total_tickets
          this.update_flag = 0
          this.update_index = 0
        } else {
          this.calculation_list.push(tempCalculation)
          calculateAll = this.calculateAll()
          this.all_total = calculateAll.total
          this.all_total_string = this.numberFormat(this.all_total, '.')
          this.total_tickets = calculateAll.total_tickets
        }
      }
    },
    editCalculation (index) {
      var tempCalculationData = this.calculation_list[index]
      this.total_label = tempCalculationData.total_label
      this.total = parseInt(tempCalculationData.total)
      this.total_string = tempCalculationData.total_string
      this.update_flag = 1
      this.update_index = index
    },
    removeCalculation (index) {
      this.calculation_list.splice(index, 1)
      var calculateAll = this.calculateAll()
      this.all_total = calculateAll.total
      this.all_total_string = this.numberFormat(this.all_total, '.')
      this.total_tickets = calculateAll.total_tickets
    },
    calculateAll () {
      var total = 0
      var totalTickets = 0
      for (var index in this.calculation_list) {
        total += parseInt(this.calculation_list[index].total)
        totalTickets += parseInt(this.calculation_list[index].tickets)
      }

      var result = {
        total: total,
        total_tickets: totalTickets
      }

      return result
    },
    submitData (confirmData) {
      if (confirmData.label === 'submit') {
        if (confirmData.flag === true) {
          this.$geb.emit({id: 'preloader', eventData: true})
          var self = this
          self.flyPostSession('frontdesk/submit_event/', {
            service: self.selected_service,
            counter: self.selected_counter,
            edc: self.selected_edc,
            edc_bank: self.edc_bank_data.id,
            payment_type: self.payment_type_data.id,
            event: self.event_data.id,
            total: self.all_total,
            calculation_list: self.calculation_list
          })
          .then(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            self.$router.push('/panel/frontdesk/dashboard/')
          })
          .catch(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            alert(response + '\n\nData tidak masuk, silahkan ulangi kembali.')
            self.errorMessage(response)
          })
        }
      }
      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .notification{
    cursor: pointer;
  }

  .overflow-table {
    max-height: 400px;
    overflow-y: scroll;
  }

  .non-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/Event.vue